import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { IssueTrackerUserFilterDTO } from '../models/issue-tracker-user-filter-dto';
import { IssueTrackerIncidenceFilterDTO } from '../models/issue-tracker-incidence-dto';

@Injectable({
  providedIn: 'root'
})

export class IssueTrackerUserFilterService {

  private pathAPI = environment.urlAPI;
  private controller = "IssueTrackerUserFilter/";

  public activeFilter = new BehaviorSubject<IssueTrackerIncidenceFilterDTO>(new IssueTrackerIncidenceFilterDTO());
  public userFilters = new BehaviorSubject<IssueTrackerUserFilterDTO[]>([]);

  constructor(private http: HttpClient) { }

  public get(id: string): Observable<IssueTrackerUserFilterDTO> {
    return this.http.get<IssueTrackerUserFilterDTO>(this.pathAPI + this.controller + id);
  }

  public post(data: IssueTrackerUserFilterDTO): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller, data);
  }

  public put(id: string, data: IssueTrackerUserFilterDTO): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + id, data);
  }

  public delete(id: string): Observable<any> {
    return this.http.delete<any>(this.pathAPI + this.controller + id);
  }

  public getAll(): Observable<IssueTrackerUserFilterDTO[]> {
    return this.http.get<IssueTrackerUserFilterDTO[]>(this.pathAPI + this.controller + 'GetAll');
  }

  setActiveFilter(value: IssueTrackerIncidenceFilterDTO) {
    window.localStorage['issueTrackerActiveFilter'] = JSON.stringify(value);
    this.activeFilter.next(value);
  }

  getActiveFilter(): Observable<IssueTrackerIncidenceFilterDTO> {   
    if (this.activeFilter.value.IdClients) {
      return this.activeFilter.asObservable();
    }
    else {
      if(window.localStorage['issueTrackerActiveFilter']){
        let filter = JSON.parse(window.localStorage['issueTrackerActiveFilter']);
        this.activeFilter.next(filter);
        return this.activeFilter.asObservable();
      }
      else {
        return of(new IssueTrackerIncidenceFilterDTO());
      }
    }
  }

  setUserFilters(value: IssueTrackerUserFilterDTO[]) {    
    this.userFilters.next(value);
  }

  getUserFilters(): Observable<IssueTrackerUserFilterDTO[]> {
    return this.userFilters.asObservable();
  }

  addUserFilter(value: IssueTrackerUserFilterDTO) {
    this.userFilters.next([...this.userFilters.value, value].sort((a, b) => a.FilterName.localeCompare(b.FilterName)));
  }

  removeUserFilter(value: IssueTrackerUserFilterDTO) {    
    this.userFilters.next(this.userFilters.value.filter(f => f.IdFilter !== value.IdFilter));
  }

}
